export const CATEGORIES = [
  { slug: 'vat',                 label: 'VAT' },
  { slug: 'payroll-rti',         label: 'Payroll & RTI' },
  { slug: 'cis',                 label: 'CIS' },
  { slug: 'making-tax-digital',  label: 'Making Tax Digital' },
  { slug: 'practice-management', label: 'Practice management' },
]

export const CATEGORY_MENU_MIN_ARTICLES = 10

export function getCategoryLabel(slug) {
  return CATEGORIES.find(c => c.slug === slug)?.label || null
}

export function getArticleCategories(article) {
  if (Array.isArray(article.category)) return article.category
  if (article.category) return [article.category]
  return []
}

export function getArticlePrimaryCategory(article) {
  const cats = getArticleCategories(article)
  return cats[0] || null
}

export const ARTICLES = [
  {
    slug:        'payroll-mid-year-handover',
    title:       'Taking on a payroll client mid-year: what to request, what to check, and what goes wrong',
    description: 'The practical mechanics of a mid-year payroll handover: P11 figures to request, the payroll ID problem, auto-enrolment status, software setup, and common errors that surface months later.',
    date:        '2026-10-16',
    author:      'Receipt Chaser team',
    category:    'payroll-rti',
  },
  {
    slug:        'pricing-fixed-fee',
    title:       'Pricing your bookkeeping practice: moving from hourly to fixed fee',
    description: 'Why hourly billing holds bookkeeping practices back, how to build a fixed-fee pricing structure, how to transition existing clients, and how to handle scope creep.',
    date:        '2026-09-22',
    author:      'Receipt Chaser team',
    category:    'practice-management',
  },
  {
    slug:        'cis-monthly-workflow',
    title:       'Running a CIS contractor scheme: the monthly workflow',
    description: 'The practical month-to-month mechanics of running a CIS contractor scheme: verification, the CIS300 monthly return, deduction statements, nil returns, and paying HMRC.',
    date:        '2026-08-18',
    author:      'Receipt Chaser team',
    category:    'cis',
  },
  {
    slug:        'mtd-itsa-first-quarter',
    title:       'MTD ITSA: preparing for the first quarterly deadline',
    description: 'The 7 August 2026 quarterly deadline is three weeks away. What bookkeepers need to check, submit, and watch out for, including exactly what the soft landing does and does not cover.',
    date:        '2026-07-17',
    author:      'Receipt Chaser team',
    category:    'making-tax-digital',
  },
  {
    slug:        'rti-common-errors',
    title:       'RTI common errors: what goes wrong and how to fix it',
    description: 'The six most common RTI errors UK bookkeepers see in practice: late FPS, missing nil EPS, wrong tax codes, incorrect year-to-date figures, wrong payment dates, and director NI. With the correct fix for each.',
    date:        '2026-06-16',
    author:      'Receipt Chaser team',
    category:    'payroll-rti',
  },
  {
    slug:        'mtd-itsa-bookkeeper-actions',
    title:       'MTD ITSA: where bookkeepers actually need to act in 2026',
    description: 'A practical guide to MTD for Income Tax for UK bookkeepers: who is in scope, what the quarterly mechanics look like, what the soft landing covers, and what to set up before the first deadline.',
    date:        '2026-05-14',
    author:      'Receipt Chaser team',
    category:    'making-tax-digital',
  },
  {
    slug:        'p11d-psa-payrolled-benefits',
    title:       'P11D, PSA, or payrolled benefits: which route for which client?',
    description: 'A guide to the three ways UK employers can report benefits in kind, when each fits, and what the April 2027 mandatory payrolling reforms mean for the decisions bookkeepers should be making in 2026/27.',
    date:        '2026-04-16',
    author:      'Receipt Chaser team',
    category:    'payroll-rti',
  },
  {
    slug:        'onboarding-new-bookkeeping-client',
    title:       'Onboarding a new bookkeeping client: a practical checklist',
    description: 'A complete onboarding sequence for UK bookkeepers: scope, AML, engagement letter, agent authorisation, professional clearance, systems setup, and the working rhythm.',
    date:        '2026-03-12',
    author:      'Receipt Chaser team',
    category:    'practice-management',
  },
  {
    slug:        'cis-contractor-subcontractor-or-both',
    title:       'CIS for bookkeepers: contractor, subcontractor, or both?',
    description: "How to spot which CIS status applies to a client, the practical mechanics of offsetting CIS deductions, and what's coming in the April 2026 reforms.",
    date:        '2026-02-18',
    author:      'Receipt Chaser team',
    category:    'cis',
  },
  {
    slug:        'vat-entertainment-vs-subsistence',
    title:       "VAT on entertainment vs subsistence: a UK bookkeeper's guide",
    description: 'When can you reclaim VAT on staff meals, client lunches, and travel food? A clear guide to the entertainment vs subsistence distinction for UK bookkeepers.',
    date:        '2026-01-22',
    author:      'Receipt Chaser team',
    category:    'vat',
  },
  {
    slug:        'chasing-receipts-from-clients',
    title:       'Chasing missing receipts from clients: the bookkeeping pain point',
    description: "Why historical-period receipt chasing is harder than it looks, what existing tools do and don't address, and where the real costs sit in a UK bookkeeping practice.",
    date:        '2025-12-15',
    author:      'Receipt Chaser team',
    category:    ['vat', 'practice-management'],
  },
]

export function getArticleBySlug(slug) {
  return ARTICLES.find(a => a.slug === slug) || null
}

export function getArticlesSorted(categorySlug) {
  let list = ARTICLES
  if (categorySlug) {
    list = list.filter(a => getArticleCategories(a).includes(categorySlug))
  }
  return [...list].sort((a, b) => {
    if (!a.date) return 1
    if (!b.date) return -1
    return b.date.localeCompare(a.date)
  })
}

export function shouldShowCategoryMenu() {
  return ARTICLES.length >= CATEGORY_MENU_MIN_ARTICLES
}

export function getCategoryCounts() {
  const counts = Object.create(null)
  for (const a of ARTICLES) {
    for (const cat of getArticleCategories(a)) {
      counts[cat] = (counts[cat] || 0) + 1
    }
  }
  return counts
}
